import React from 'react'
import QuestionCard from './QuestionCard'
import RadioOption from './RadioOption'

interface SectionProps {
  formData: Record<string, any>
  updateField: (field: string, value: any) => void
}

/**
 * Section D — Governance (Q11-Q14).
 * Collects information about AI leadership, investment, impact
 * measurement, and team training.
 */
const SectionD: React.FC<SectionProps> = ({ formData, updateField }) => {
  return (
    <div className="flex flex-col gap-6">
      {/* Q11 — Liderança de IA */}
      <QuestionCard
        title="Quem lidera as iniciativas de IA na sua operação?"
        required
      >
        <RadioOption
          name="q11"
          value="fundador"
          label="Eu mesmo(a) / fundador(a)"
          selected={formData.q11 === 'fundador'}
          onChange={(v) => updateField('q11', v)}
        />
        <RadioOption
          name="q11"
          value="time_tecnologia"
          label="Time de tecnologia / TI"
          selected={formData.q11 === 'time_tecnologia'}
          onChange={(v) => updateField('q11', v)}
        />
        <RadioOption
          name="q11"
          value="time_marketing"
          label="Time de marketing"
          selected={formData.q11 === 'time_marketing'}
          onChange={(v) => updateField('q11', v)}
        />
        <RadioOption
          name="q11"
          value="time_operacoes"
          label="Time de operações"
          selected={formData.q11 === 'time_operacoes'}
          onChange={(v) => updateField('q11', v)}
        />
        <RadioOption
          name="q11"
          value="ninguem_especifico"
          label="Ninguém específico — cada um usa por conta"
          selected={formData.q11 === 'ninguem_especifico'}
          onChange={(v) => updateField('q11', v)}
        />
        <RadioOption
          name="q11"
          value="consultoria_externa"
          label="Consultoria / agência externa"
          selected={formData.q11 === 'consultoria_externa'}
          onChange={(v) => updateField('q11', v)}
        />
      </QuestionCard>

      {/* Q12 — Investimento em ferramentas de IA */}
      <QuestionCard
        title="Quanto você investe em ferramentas de IA por mês (além do time)?"
        required
      >
        <RadioOption
          name="q12"
          value="nada_gratuitas"
          label="Nada (só ferramentas gratuitas)"
          selected={formData.q12 === 'nada_gratuitas'}
          onChange={(v) => updateField('q12', v)}
        />
        <RadioOption
          name="q12"
          value="ate_500"
          label="Até R$500/mês"
          selected={formData.q12 === 'ate_500'}
          onChange={(v) => updateField('q12', v)}
        />
        <RadioOption
          name="q12"
          value="500_2000"
          label="R$500 - R$2.000/mês"
          selected={formData.q12 === '500_2000'}
          onChange={(v) => updateField('q12', v)}
        />
        <RadioOption
          name="q12"
          value="2000_5000"
          label="R$2.000 - R$5.000/mês"
          selected={formData.q12 === '2000_5000'}
          onChange={(v) => updateField('q12', v)}
        />
        <RadioOption
          name="q12"
          value="mais_5000"
          label="Mais de R$5.000/mês"
          selected={formData.q12 === 'mais_5000'}
          onChange={(v) => updateField('q12', v)}
        />
        <RadioOption
          name="q12"
          value="nao_sei"
          label="Não sei"
          selected={formData.q12 === 'nao_sei'}
          onChange={(v) => updateField('q12', v)}
        />
      </QuestionCard>

      {/* Q13 — Medição de impacto */}
      <QuestionCard
        title="Você mede o impacto da IA nos resultados?"
        required
      >
        <RadioOption
          name="q13"
          value="sim_metricas_claras"
          label="Sim, com métricas claras (tempo economizado, receita, etc.)"
          selected={formData.q13 === 'sim_metricas_claras'}
          onChange={(v) => updateField('q13', v)}
        />
        <RadioOption
          name="q13"
          value="mais_ou_menos"
          label="Mais ou menos — tenho uma noção mas não meço formalmente"
          selected={formData.q13 === 'mais_ou_menos'}
          onChange={(v) => updateField('q13', v)}
        />
        <RadioOption
          name="q13"
          value="nao_meco"
          label="Não meço"
          selected={formData.q13 === 'nao_meco'}
          onChange={(v) => updateField('q13', v)}
        />
      </QuestionCard>

      {/* Q14 — Treinamento da equipe */}
      <QuestionCard
        title="Sua equipe recebeu algum treinamento formal para usar IA?"
        required
      >
        <RadioOption
          name="q14"
          value="treinamento_estruturado"
          label="Sim, treinamento estruturado"
          selected={formData.q14 === 'treinamento_estruturado'}
          onChange={(v) => updateField('q14', v)}
        />
        <RadioOption
          name="q14"
          value="treinamentos_informais"
          label="Sim, treinamentos informais / autodidatas"
          selected={formData.q14 === 'treinamentos_informais'}
          onChange={(v) => updateField('q14', v)}
        />
        <RadioOption
          name="q14"
          value="cada_um_aprende"
          label="Não, cada um aprende sozinho"
          selected={formData.q14 === 'cada_um_aprende'}
          onChange={(v) => updateField('q14', v)}
        />
        <RadioOption
          name="q14"
          value="nao_e_precisariamos"
          label="Não, e acho que precisaríamos"
          selected={formData.q14 === 'nao_e_precisariamos'}
          onChange={(v) => updateField('q14', v)}
        />
      </QuestionCard>
    </div>
  )
}

export default SectionD
